import { Link, NavLink, useLocation } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'
import { FiUser, FiLogOut, FiChevronDown, FiChevronRight } from 'react-icons/fi'
import api from '../../utils/api'
import './navbar.css'
import logo from '../img/logo.png'
import Bell from './Bell'
import Modal from '../modal/Modal'
import Perfil from '../../pages/Perfil/Perfil'

import useMyPermission from '../../hooks/useMyPermission'
import { Context } from '../../context/UserContext'

function Navbar() {

  const { authenticated, logout } = useContext(Context)
  const location = useLocation()
  const [modalPerfil, setModalPerfil] = useState(false)

  const [myPermission, setMyPermission] = useState({ group: "" })
  const { checkPermission } = useMyPermission()
  const myPermissionServiceExpEdit   = checkPermission(myPermission, "serviceExp_Edit")
  const myPermissionServiceExpDelete = checkPermission(myPermission, "serviceExp_Delete")
  const myPermissionServiceExpView   = checkPermission(myPermission, "serviceExp_View")
  const myPermissionServiceExpCreate = checkPermission(myPermission, "serviceExp_Create")

  const myPermissionClientEdit   = checkPermission(myPermission, "client_Edit")
  const myPermissionClientDelete = checkPermission(myPermission, "client_Delete")
  const myPermissionClientView   = checkPermission(myPermission, "client_View")

  const myPermissionMyClientView = checkPermission(myPermission, "myClient_View")

  const myPermissionGeneratorView   = checkPermission(myPermission, "generator_View")
  const myPermissionRegionView = checkPermission(myPermission, "region_View")
  const myPermissionServiceOrderView = checkPermission(myPermission, "serviceOrder_View")
  const myPermissionServiceOrderOpenView = checkPermission(myPermission, "serviceOrderOpen_View")
  const myPermissionServiceOrderReviewView = checkPermission(myPermission, "serviceOrderReview_View")
  const myPermissionServiceOrderConcludedView = checkPermission(myPermission, "serviceOrderConcluded_View")
  const myPermissionScheduleView = checkPermission(myPermission, "schedule_View")
  const myPermissionChecklistGroupView = checkPermission(myPermission, "checklistGroup_View")
  const myPermissionChecklistItemView = checkPermission(myPermission, "checklistItem_View")
  const myPermissionProcedureView = checkPermission(myPermission, "procedure_View")
  const myPermissionHistoricView = checkPermission(myPermission, "historic_View")
  const myPermissionBackupView = checkPermission(myPermission, "backup_View")

  const isAdminGroup = myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER"

  const showInicioMenu = myPermissionClientView || myPermissionMyClientView || myPermissionGeneratorView || myPermissionRegionView
  const showServiceOrderSubmenu = myPermissionServiceOrderView || myPermissionServiceOrderOpenView
    || myPermissionServiceOrderReviewView || myPermissionServiceOrderConcludedView
  const showManutencaoMenu = myPermissionGeneratorView || myPermissionServiceExpView || showServiceOrderSubmenu
    || myPermissionScheduleView || myPermissionChecklistGroupView || myPermissionChecklistItemView || myPermissionProcedureView
  const showChecklistSubmenu = myPermissionChecklistGroupView || myPermissionChecklistItemView || myPermissionProcedureView

  const userName = localStorage.getItem('userName')
  const userFirstName = userName ? userName.trim().split(' ')[0] : userName

  const isInicioActive     = ['/client', '/myclient', '/generator', '/region'].some(p => location.pathname.startsWith(p))
  const isManutencaoActive = ['/horimetro', '/serviceOrder', '/maintenanceSchedule', '/procedure', '/checklistGroup', '/checklistItem'].some(p => location.pathname.startsWith(p))
  const isChecklistActive  = ['/checklistGroup', '/checklistItem', '/procedure'].some(p => location.pathname.startsWith(p))
  const isServiceOrderActive = location.pathname.startsWith('/serviceOrder')
  const isUsuariosActive   = ['/system-user', '/Historic', '/backup'].some(p => location.pathname.startsWith(p))

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      api.get('/user/get/permission', {
        headers: { Authorization: `Bearer ${JSON.parse(token)}` }
      }).then((response) => {
        setMyPermission(response.data.permission)
      })
    }
  }, [])

  if (authenticated) {
    return (
      <>
      <nav className="navbar">
        <div className='navbar-left-side'>
          <Link to="/" className='navbar-logo'>
            <img className='navbar-logo-img' src={logo} alt="BestForce" />
          </Link>

          <div className='navbar-separator' />

          <div className='navbar-options'>

            {showInicioMenu &&
              <div className="dropdown">
                <Link to="/" className={`dropbtn${isInicioActive ? ' dropbtn-active' : ''}`}>
                  Início <FiChevronDown size={12} className="dropbtn-chevron" />
                </Link>
                <div className="dropdown-content">
                  {myPermissionClientView   && <NavLink to="/client">Clientes</NavLink>}
                  {myPermissionMyClientView && <NavLink to="/myclient">Meus Clientes</NavLink>}
                  {myPermissionGeneratorView && <NavLink to="/generator">Geradores</NavLink>}
                  {myPermissionRegionView  && <NavLink to="/region/list">Regiões</NavLink>}
                </div>
              </div>
            }

            {showManutencaoMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isManutencaoActive ? ' dropbtn-active' : ''}`}>
                  Manutenção <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {myPermissionGeneratorView  && <NavLink to="/generator">Geradores</NavLink>}
                  {myPermissionServiceExpView && <NavLink className='navbar-option-item' to="/horimetro/list">Serviços e Prazos</NavLink>}
                  {showServiceOrderSubmenu &&
                    <div className="submenu">
                      <div className={`submenu-trigger${isServiceOrderActive ? ' submenu-trigger-active' : ''}`}>
                        Ordem de Serviço <FiChevronRight size={12} className="submenu-chevron" />
                      </div>
                      <div className="submenu-content">
                        {myPermissionServiceOrderView && <NavLink className='navbar-option-item' to="/serviceOrder">Cadastrar</NavLink>}
                        {myPermissionServiceOrderOpenView && <NavLink className='navbar-option-item' to="/serviceOrderOpen">Em Aberto</NavLink>}
                        {myPermissionServiceOrderReviewView && <NavLink className='navbar-option-item' to="/serviceOrderReview">Em Análise</NavLink>}
                        {myPermissionServiceOrderConcludedView && <NavLink className='navbar-option-item' to="/serviceOrderConcluded">Concluídas</NavLink>}
                      </div>
                    </div>
                  }
                  {myPermissionScheduleView && <NavLink className='navbar-option-item' to="/maintenanceSchedule">Quadro de Manutenção</NavLink>}
                  {showChecklistSubmenu &&
                    <div className="submenu">
                      <div className={`submenu-trigger${isChecklistActive ? ' submenu-trigger-active' : ''}`}>
                        Checklist <FiChevronRight size={12} className="submenu-chevron" />
                      </div>
                      <div className="submenu-content">
                        {myPermissionChecklistGroupView && <NavLink className='navbar-option-item' to="/checklistGroup">Grupos de Checklist</NavLink>}
                        {myPermissionChecklistItemView && <NavLink className='navbar-option-item' to="/checklistItem">Itens de Checklist</NavLink>}
                        {myPermissionProcedureView && <NavLink className='navbar-option-item' to="/procedure">Procedimentos</NavLink>}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }

            {(isAdminGroup || myPermissionHistoricView || myPermissionBackupView) &&
              <div className="dropdown">
                <li className={`dropbtn${isUsuariosActive ? ' dropbtn-active' : ''}`}>
                  Administrador <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {isAdminGroup && <NavLink to="/system-user/list">Usuários</NavLink>}
                  {myPermissionHistoricView && <NavLink to="/Historic/list">Histórico</NavLink>}
                  {myPermissionBackupView && <NavLink to="/backup">Backup</NavLink>}
                </div>
              </div>
            }

          </div>
        </div>

        <div className='navbar-right-side'>
          <Bell />
          <div className='navbar-user-area' onClick={() => setModalPerfil(true)}>
            <FiUser size={15} className='navbar-user-icon' />
            <span className='navbar-user-name'>{userFirstName}</span>
          </div>
          <div className='navbar-logout' onClick={logout}>
            <FiLogOut size={15} />
            <span>Sair</span>
          </div>
        </div>

      </nav>

      <Modal
        modalStatus={modalPerfil}
        changeStatus={setModalPerfil}
        w={40}
        h={62}
        content={
          <Perfil btCancelAction={() => setModalPerfil(false)} />
        }
      />
    </>
    )
  } else {
    return (<div></div>)
  }
}

export default Navbar
